import { gql } from '@apollo/client'

export const GET_TABLE_TERRITORY_RELEVANCE = gql`
  query getTableTerritoryRelevance($territoryId: ID!, $countries: [String!], $genders: [String!], $ages: [String!]) {
    getTerritory(territoryId: $territoryId) {
      name
      territoryId
      territoryPerformance {
        relevancev2(
          audience: { countries: $countries, genders: $genders, ages: $ages }
          filters: { timeRange: { timeUnit: month, timeValue: 12 }, interval: { timeUnit: month, type: calendar } }
        ) {
          endDate
          total
          sparkline
          startDate
        }
      }
    }
  }
`
